export const LOOKUP = 'branches/lookup/LOOKUP'
export const LOOKUP_REQUEST = 'branches/lookup/LOOKUP_REQUEST'
export const LOOKUP_FAIL = 'branches/lookup/LOOKUP_FAIL'
export const LOOKUP_SUCCESS = 'branches/lookup/LOOKUP_SUCCESS'
export const LOOKUP_RESET = 'branches/lookup/LOOKUP_RESET'